module.exports = __webpack_public_path__ + "img/booongo_slot.9137718f.png";